import { VStack, Heading, Text, Icon, Button, useToast } from '@chakra-ui/react';
import { FaBrain } from 'react-icons/fa';

export default function EmptyState() {
  const toast = useToast();

  const handleShowCoach = () => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.removeItem('ekkos.onboardingDone');
      window.dispatchEvent(new CustomEvent('ekkos:onboardingReset'));
    } catch (err) {
      console.error('Failed to restart onboarding coach', err);
      toast({
        title: 'Unable to start coach',
        description: 'Please try again.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
<VStack
  className="empty-state-card"
  spacing={6}
  p={10}
  rounded="lg"
  textAlign="center"
  w="100%"
>
      <Icon as={FaBrain} boxSize={12} color="purple.400" />
      <Heading size="lg" color="purple.300">
        Nothing yet!
      </Heading>
      <Text color="gray.400" maxW="md">
        Start by typing a task and time in the command palette below.
      </Text>
      <Text color="gray.400" maxW="md">
      Use natural language, like "Remind me to call mom in 2 hours" or "Meeting with team tomorrow at 10am".
      </Text>
      <Button
        variant="outline"
        colorScheme="blue"
        size="sm"
        onClick={handleShowCoach}
      >
        Show Me!
      </Button>
    </VStack>
  );
}
